const EmptyState = ({ icon: Icon, title, description, action }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center px-4">
      {Icon && (
        <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-surface-100 dark:bg-surface-800">
          <Icon size={28} className="text-surface-400" />
        </div>
      )}
      <h3 className="mb-1.5 text-base font-bold text-surface-700 dark:text-surface-300">{title}</h3>
      {description && (
        <p className="mb-6 max-w-xs text-sm text-surface-400 leading-relaxed">{description}</p>
      )}
      {action && action}
    </div>
  );
};

export default EmptyState;
